import React from 'react'

export default function Home() {
  
  return (
    <div className='App-home'>
        <h1>Bamomas Battery - API Call app</h1>
        <h4>Features</h4>
        <ul>
           <li>Fetch data and display in a table </li>
           <li>Filter by location, connection status columun </li>
           <li>Sort by id, voltage, capacity, connection status, connectio time, charge state, health state , and number of issues</li>
           <li>Reset sort </li>
           <li>Use react hooks, useEffect, useState</li>
           <li>Display a single Battery object in separate page accessed by clicking Object Id </li>
           <li>React Router , to navigate through pages</li>
           <li>Displays No page for non existing route </li>
           <li>Render Pending component while data is loading</li>
           <li>Only plain css styling used , no other css framworks are implemented</li>
           <li>Some fontawsome icons are included</li>
           <li>Small reusable components</li>
           <li>Pagination;  split the whole bulk data in to small chunk and renders it  without calling the api repeatdly </li>
           <li>Media qurey is used to create more than one layouts for different size viewport  </li>
           <li>Helper objects are used to match and represent numerical data with meaningful word expressions </li>
           <li>State of charge measurments is displayed  in Line chart by using React Google charts liberary  </li>
           
        </ul>
        <h4>How to Run</h4>
        <ul>
          CMD
          <li>
            $ yarn install
          </li>
          <li>
            $ yarn start 
          </li>
          <li>
            visit - localhost:3000
          </li>
        </ul>
        <h4>Bug to be fixed </h4>
          <p>React is complaing about using selected keyward in Select html option tag. To be fixed</p>
        <h4>Link </h4>
      <a href='https://teyeb-battery.netlify.app/' target="_blank" rel="noreferrer">https://teyeb-battery.netlify.app/</a>
      <br></br>
      <button className='go-to-top-btn' onClick={() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto",
        })
      }}>Go to top </button>
    </div>
  )
}
